import React, { useState } from "react";
import RazorpayPayment from "../../BuyerProfile/Payment/RazorpayPayment";

const PricingPlanContents = [
  "Listing on Naayatrade",
  "Customize Seller Dashboard",
  "Unlimited product listing",
  "SEO keywords",
  "Digital catalog",
  "Business verification support",
  "Dedicated accounts manager",
  "Trusted tag of Naayatrade",
  "Website - webstore front",
  "Business journey video-shoot",
  "Product's HD shoot",
  "Infographic images",

  "Infographic videos",
  "Creative",
  "PDF version of catalog",
  "Logistic support",
  "Payment integration",
  "Estimated leads",
  "Interactive Digital vCard",
  "SSL secure connection",
  "Sponsored banners",
  "Email booking",
  "Domain booking",
  "Super Naayatrade seller batch",
  "Personal web-application",
  "WhatsApp notification",
  "Email notification / SMS notification",
  "Regional Language operational view",
  "CRM+ LRM enhanced features",
  "Dedicated SEO Services",
  "Google adword worth",
];

const RegisterPricingPlan = ({
  selectedPlan,
  setSelectedPlan,
  planError,
  setPlanError,
}) => {
  const handlePlanSelect = (plan) => {
    setSelectedPlan(plan);
  };

  return (
    // <div className="w-full h-[1300px] flex items-center justify-center">
    <div className="w-[1055px] h-[1539px] rounded-[20px] bg-white flex flex-col items-center justify-start">
      <img
        src={require("../../../assets/BuyerProfile/StoreManager/PricingPlan/Logo.jpg")}
        alt=""
        className="w-[31px] h-[39px]"
      />
      <h3 className="w-[92px] h-[21px] font-semibold text-[14px] text-black text-center mt-[16px]">
        Pricing Plans
      </h3>

      <div className="w-auto h-[1339px] flex flex-row gap-x-[20px] mt-[29px]">
        <div className="flex flex-col">
          <h3 className="w-[90px] h-[39px] text-start font-semibold text-[18px] mt-[30px]">
            Features
          </h3>
          <ul className="list-disc space-y-[21px] font-medium text-black text-start text-[12px] mt-[27px]">
            {PricingPlanContents.map((feature, index) => (
              <li key={index}>{feature}</li>
            ))}
          </ul>
        </div>

        <button
          className={`w-[229px] h-[1339px] border rounded-[10px] pt-[22px] pb-[46px] px-[20px] flex flex-col ${
            selectedPlan === 0 && "border-[#FF6300] border-[3px]"
          }`}
          onClick={() => {
            handlePlanSelect(0);
            setPlanError("");
          }}
        >
          <div className="w-full flex flex-row items-center justify-between">
            <div className="flex flex-row w-[69px] items-center justify-between">
              <img
                src={require("../../../assets/BuyerProfile/StoreManager/PricingPlan/Elite.jpg")}
                alt=""
                className="w-[20px] h-[25px]"
              />
              <p className="w-[40px] h-[21px] font-semibold text-[14px] text-start text-black">
                Gold
              </p>
            </div>
            <p className="w-[60px] text-end h-[44px] font-semibold text-[16px] text-black leading-[22px]">
              ₹ 2,999{" "}
              <span className="font-regular text-[12px] text-black">
                / month
              </span>
            </p>
          </div>
          <div className="w-[189px] h-auto mt-[19px] [&>*:nth-child(odd)]:bg-[#F2F2F2] [&>*:nth-child(even)]:bg-white">
            <p className="w-[189px] h-[39px] flex items-center justify-center">
              <svg
                width="18"
                height="19"
                viewBox="0 0 18 19"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0_703_1449)">
                  <path
                    d="M3.75 9.49984L7.5 13.4582L15 5.5415"
                    stroke="#72C62F"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </g>
              </svg>
            </p>
            <p className="w-[189px] h-[39px] flex items-center justify-center">
              <svg
                width="18"
                height="19"
                viewBox="0 0 18 19"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0_703_1449)">
                  <path
                    d="M3.75 9.49984L7.5 13.4582L15 5.5415"
                    stroke="#72C62F"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </g>
              </svg>
            </p>
            <p className="w-[189px] h-[39px] flex items-center justify-center">
              <svg
                width="18"
                height="19"
                viewBox="0 0 18 19"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0_703_1449)">
                  <path
                    d="M3.75 9.49984L7.5 13.4582L15 5.5415"
                    stroke="#72C62F"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </g>
              </svg>
            </p>
            <p className="w-[189px] h-[39px] flex items-center justify-center text-[14px] font-semibold">
              50
            </p>
            <p className="w-[189px] h-[39px] flex items-center justify-center text-[14px] font-semibold">
              3 Pages
            </p>
            <p className="w-[189px] h-[39px] flex items-center justify-center">
              <svg
                width="18"
                height="19"
                viewBox="0 0 18 19"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0_703_1449)">
                  <path
                    d="M3.75 9.49984L7.5 13.4582L15 5.5415"
                    stroke="#72C62F"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </g>
              </svg>
            </p>
            <p className="w-[189px] h-[39px] text-[#FF6300] font-semibold flex items-center justify-center">
              -
            </p>
            <p className="w-[189px] h-[39px] flex items-center justify-center">
              <svg
                width="18"
                height="19"
                viewBox="0 0 18 19"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0_703_1449)">
                  <path
                    d="M3.75 9.49984L7.5 13.4582L15 5.5415"
                    stroke="#72C62F"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </g>
              </svg>
            </p>
            <p className="w-[189px] h-[39px] flex items-center justify-center">
              <svg
                width="18"
                height="19"
                viewBox="0 0 18 19"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0_703_1449)">
                  <path
                    d="M3.75 9.49984L7.5 13.4582L15 5.5415"
                    stroke="#72C62F"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </g>
              </svg>
            </p>
            <p className="w-[189px] h-[39px] flex items-center justify-center">
              <svg
                width="18"
                height="19"
                viewBox="0 0 18 19"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0_703_1449)">
                  <path
                    d="M3.75 9.49984L7.5 13.4582L15 5.5415"
                    stroke="#72C62F"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </g>
              </svg>
            </p>
            <p className="w-[189px] h-[39px] flex items-center justify-center">
              <svg
                width="18"
                height="19"
                viewBox="0 0 18 19"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0_703_1449)">
                  <path
                    d="M3.75 9.49984L7.5 13.4582L15 5.5415"
                    stroke="#72C62F"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </g>
              </svg>
            </p>
            <p className="w-[189px] h-[39px] flex items-center justify-center text-[14px] font-semibold">
              48 Images
            </p>
            <p className="w-[189px] h-[39px] flex items-center justify-center text-[14px] font-semibold">
              48 Videos
            </p>
            <p className="w-[189px] h-[39px] flex items-center justify-center">
              <svg
                width="18"
                height="19"
                viewBox="0 0 18 19"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0_703_1449)">
                  <path
                    d="M3.75 9.49984L7.5 13.4582L15 5.5415"
                    stroke="#72C62F"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </g>
              </svg>
            </p>
            <p className="w-[189px] h-[39px] flex items-center justify-center">
              <svg
                width="18"
                height="19"
                viewBox="0 0 18 19"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0_703_1449)">
                  <path
                    d="M3.75 9.49984L7.5 13.4582L15 5.5415"
                    stroke="#72C62F"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </g>
              </svg>
            </p>
            <p className="w-[189px] h-[39px] flex items-center justify-center">
              <svg
                width="18"
                height="19"
                viewBox="0 0 18 19"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0_703_1449)">
                  <path
                    d="M3.75 9.49984L7.5 13.4582L15 5.5415"
                    stroke="#72C62F"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </g>
              </svg>
            </p>
            <p className="w-[189px] h-[39px] flex items-center justify-center">
              <svg
                width="18"
                height="19"
                viewBox="0 0 18 19"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0_703_1449)">
                  <path
                    d="M3.75 9.49984L7.5 13.4582L15 5.5415"
                    stroke="#72C62F"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </g>
              </svg>
            </p>
            <p className="w-[189px] h-[39px] flex items-center justify-center text-[14px] font-semibold">
              120 - 200
            </p>
            <p className="w-[189px] h-[39px] flex items-center justify-center">
              <svg
                width="18"
                height="19"
                viewBox="0 0 18 19"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0_703_1449)">
                  <path
                    d="M3.75 9.49984L7.5 13.4582L15 5.5415"
                    stroke="#72C62F"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </g>
              </svg>
            </p>
            <p className="w-[189px] h-[39px] flex items-center justify-center text-[#FF6300] font-semibold">
              -
            </p>
            <p className="w-[189px] h-[39px] flex items-center justify-center text-[#FF6300] font-semibold">
              -
            </p>
            <p className="w-[189px] h-[39px] flex items-center justify-center text-[#FF6300] font-semibold">
              -
            </p>
            <p className="w-[189px] h-[39px] flex items-center justify-center text-[#FF6300] font-semibold">
              -
            </p>
            <p className="w-[189px] h-[39px] flex items-center justify-center text-[#FF6300] font-semibold">
              -
            </p>
            <p className="w-[189px] h-[39px] flex items-center justify-center text-[#FF6300] font-semibold">
              -
            </p>
            <p className="w-[189px] h-[39px] flex items-center justify-center text-[#FF6300] font-semibold">
              -
            </p>
            <p className="w-[189px] h-[39px] flex items-center justify-center text-[#FF6300] font-semibold">
              <svg
                width="18"
                height="19"
                viewBox="0 0 18 19"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0_703_1449)">
                  <path
                    d="M3.75 9.49984L7.5 13.4582L15 5.5415"
                    stroke="#72C62F"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </g>
              </svg>
            </p>
            <p className="w-[189px] h-[39px] flex items-center justify-center text-[#FF6300] font-semibold">
              <svg
                width="18"
                height="19"
                viewBox="0 0 18 19"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0_703_1449)">
                  <path
                    d="M3.75 9.49984L7.5 13.4582L15 5.5415"
                    stroke="#72C62F"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </g>
              </svg>
            </p>
            <p className="w-[189px] h-[39px] flex items-center justify-center text-[14px] font-semibold">
              Basic
            </p>
            <p className="w-[189px] h-[39px] flex items-center justify-center text-[#FF6300] font-semibold">
              -
            </p>
            <p className="w-[189px] h-[39px] flex items-center justify-center text-[#FF6300] font-semibold">
              <svg
                width="18"
                height="19"
                viewBox="0 0 18 19"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0_703_1449)">
                  <path
                    d="M3.75 9.49984L7.5 13.4582L15 5.5415"
                    stroke="#72C62F"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </g>
              </svg>
            </p>
          </div>
        </button>

        <button
          className={`w-[229px] h-[1339px] border rounded-[10px] pt-[22px] pb-[46px] px-[20px] flex flex-col ${
            selectedPlan === 1 && "border-[#FF6300] border-[3px]"
          }`}
          onClick={() => {
            handlePlanSelect(1);
            setPlanError("");
          }}
        >
          <div className="w-full flex flex-row items-center justify-between">
            <div className="flex flex-row w-[95px] items-center justify-between">
              <img
                src={require("../../../assets/BuyerProfile/StoreManager/PricingPlan/Logo.jpg")}
                alt=""
                className="w-[20px] h-[25px]"
              />
              <p className="w-[68px] h-[21px] font-semibold text-[14px] text-start text-black">
                Premium
              </p>
            </div>
            <p className="w-[60px] text-end h-[44px] font-semibold text-[16px] text-black leading-[22px]">
              ₹ 9,999{" "}
              <span className="font-regular text-[12px] text-black">
                / month
              </span>
            </p>
          </div>
          <div className="w-[189px] h-auto mt-[19px] [&>*:nth-child(odd)]:bg-[#F2F2F2] [&>*:nth-child(even)]:bg-white">
            <p className="w-[189px] h-[39px] flex items-center justify-center">
              <svg
                width="18"
                height="19"
                viewBox="0 0 18 19"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0_703_1449)">
                  <path
                    d="M3.75 9.49984L7.5 13.4582L15 5.5415"
                    stroke="#72C62F"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </g>
              </svg>
            </p>
            <p className="w-[189px] h-[39px] flex items-center justify-center">
              <svg
                width="18"
                height="19"
                viewBox="0 0 18 19"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0_703_1449)">
                  <path
                    d="M3.75 9.49984L7.5 13.4582L15 5.5415"
                    stroke="#72C62F"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </g>
              </svg>
            </p>
            <p className="w-[189px] h-[39px] flex items-center justify-center">
              <svg
                width="18"
                height="19"
                viewBox="0 0 18 19"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0_703_1449)">
                  <path
                    d="M3.75 9.49984L7.5 13.4582L15 5.5415"
                    stroke="#72C62F"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </g>
              </svg>
            </p>
            <p className="w-[189px] h-[39px] flex items-center justify-center text-[14px] font-semibold">
              250
            </p>
            <p className="w-[189px] h-[39px] flex items-center justify-center text-[14px] font-semibold">
              6 Pages
            </p>
            <p className="w-[189px] h-[39px] flex items-center justify-center">
              <svg
                width="18"
                height="19"
                viewBox="0 0 18 19"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0_703_1449)">
                  <path
                    d="M3.75 9.49984L7.5 13.4582L15 5.5415"
                    stroke="#72C62F"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </g>
              </svg>
            </p>
            <p className="w-[189px] h-[39px] flex items-center justify-center">
              <svg
                width="18"
                height="19"
                viewBox="0 0 18 19"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0_703_1449)">
                  <path
                    d="M3.75 9.49984L7.5 13.4582L15 5.5415"
                    stroke="#72C62F"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </g>
              </svg>
            </p>
            <p className="w-[189px] h-[39px] flex items-center justify-center">
              <svg
                width="18"
                height="19"
                viewBox="0 0 18 19"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0_703_1449)">
                  <path
                    d="M3.75 9.49984L7.5 13.4582L15 5.5415"
                    stroke="#72C62F"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </g>
              </svg>
            </p>
            <p className="w-[189px] h-[39px] flex items-center justify-center">
              <svg
                width="18"
                height="19"
                viewBox="0 0 18 19"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0_703_1449)">
                  <path
                    d="M3.75 9.49984L7.5 13.4582L15 5.5415"
                    stroke="#72C62F"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </g>
              </svg>
            </p>
            <p className="w-[189px] h-[39px] flex items-center justify-center">
              <svg
                width="18"
                height="19"
                viewBox="0 0 18 19"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0_703_1449)">
                  <path
                    d="M3.75 9.49984L7.5 13.4582L15 5.5415"
                    stroke="#72C62F"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </g>
              </svg>
            </p>
            <p className="w-[189px] h-[39px] flex items-center justify-center">
              <svg
                width="18"
                height="19"
                viewBox="0 0 18 19"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0_703_1449)">
                  <path
                    d="M3.75 9.49984L7.5 13.4582L15 5.5415"
                    stroke="#72C62F"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </g>
              </svg>
            </p>
            <p className="w-[189px] h-[39px] flex items-center justify-center text-[14px] font-semibold">
              120 Images
            </p>
            <p className="w-[189px] h-[39px] flex items-center justify-center text-[14px] font-semibold">
              96 Videos
            </p>
            <p className="w-[189px] h-[39px] flex items-center justify-center">
              <svg
                width="18"
                height="19"
                viewBox="0 0 18 19"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0_703_1449)">
                  <path
                    d="M3.75 9.49984L7.5 13.4582L15 5.5415"
                    stroke="#72C62F"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </g>
              </svg>
            </p>
            <p className="w-[189px] h-[39px] flex items-center justify-center">
              <svg
                width="18"
                height="19"
                viewBox="0 0 18 19"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0_703_1449)">
                  <path
                    d="M3.75 9.49984L7.5 13.4582L15 5.5415"
                    stroke="#72C62F"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </g>
              </svg>
            </p>
            <p className="w-[189px] h-[39px] flex items-center justify-center">
              <svg
                width="18"
                height="19"
                viewBox="0 0 18 19"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0_703_1449)">
                  <path
                    d="M3.75 9.49984L7.5 13.4582L15 5.5415"
                    stroke="#72C62F"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </g>
              </svg>
            </p>
            <p className="w-[189px] h-[39px] flex items-center justify-center">
              <svg
                width="18"
                height="19"
                viewBox="0 0 18 19"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0_703_1449)">
                  <path
                    d="M3.75 9.49984L7.5 13.4582L15 5.5415"
                    stroke="#72C62F"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </g>
              </svg>
            </p>
            <p className="w-[189px] h-[39px] flex items-center justify-center text-[14px] font-semibold">
              410 - 500
            </p>
            <p className="w-[189px] h-[39px] flex items-center justify-center">
              <svg
                width="18"
                height="19"
                viewBox="0 0 18 19"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0_703_1449)">
                  <path
                    d="M3.75 9.49984L7.5 13.4582L15 5.5415"
                    stroke="#72C62F"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </g>
              </svg>
            </p>
            <p className="w-[189px] h-[39px] flex items-center justify-center">
              <svg
                width="18"
                height="19"
                viewBox="0 0 18 19"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0_703_1449)">
                  <path
                    d="M3.75 9.49984L7.5 13.4582L15 5.5415"
                    stroke="#72C62F"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </g>
              </svg>
            </p>
            <p className="w-[189px] h-[39px] flex items-center justify-center">
              <svg
                width="18"
                height="19"
                viewBox="0 0 18 19"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0_703_1449)">
                  <path
                    d="M3.75 9.49984L7.5 13.4582L15 5.5415"
                    stroke="#72C62F"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </g>
              </svg>
            </p>
            <p className="w-[189px] h-[39px] flex items-center justify-center">
              <svg
                width="18"
                height="19"
                viewBox="0 0 18 19"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0_703_1449)">
                  <path
                    d="M3.75 9.49984L7.5 13.4582L15 5.5415"
                    stroke="#72C62F"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </g>
              </svg>
            </p>
            <p className="w-[189px] h-[39px] flex items-center justify-center">
              <svg
                width="18"
                height="19"
                viewBox="0 0 18 19"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0_703_1449)">
                  <path
                    d="M3.75 9.49984L7.5 13.4582L15 5.5415"
                    stroke="#72C62F"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </g>
              </svg>
            </p>
            <p className="w-[189px] h-[39px] flex items-center justify-center">
              <svg
                width="18"
                height="19"
                viewBox="0 0 18 19"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0_703_1449)">
                  <path
                    d="M3.75 9.49984L7.5 13.4582L15 5.5415"
                    stroke="#72C62F"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </g>
              </svg>
            </p>
            <p className="w-[189px] h-[39px] flex items-center justify-center">
              <svg
                width="18"
                height="19"
                viewBox="0 0 18 19"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0_703_1449)">
                  <path
                    d="M3.75 9.49984L7.5 13.4582L15 5.5415"
                    stroke="#72C62F"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </g>
              </svg>
            </p>
            <p className="w-[189px] h-[39px] flex items-center justify-center">
              <svg
                width="18"
                height="19"
                viewBox="0 0 18 19"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0_703_1449)">
                  <path
                    d="M3.75 9.49984L7.5 13.4582L15 5.5415"
                    stroke="#72C62F"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </g>
              </svg>
            </p>
            <p className="w-[189px] h-[39px] flex items-center justify-center">
              <svg
                width="18"
                height="19"
                viewBox="0 0 18 19"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0_703_1449)">
                  <path
                    d="M3.75 9.49984L7.5 13.4582L15 5.5415"
                    stroke="#72C62F"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </g>
              </svg>
            </p>
            <p className="w-[189px] h-[39px] flex items-center justify-center">
              <svg
                width="18"
                height="19"
                viewBox="0 0 18 19"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0_703_1449)">
                  <path
                    d="M3.75 9.49984L7.5 13.4582L15 5.5415"
                    stroke="#72C62F"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </g>
              </svg>
            </p>
            <p className="w-[189px] h-[39px] flex items-center justify-center text-[14px] font-semibold">
              Enhanced
            </p>
            <p className="w-[189px] h-[39px] flex items-center justify-center">
              <svg
                width="18"
                height="19"
                viewBox="0 0 18 19"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0_703_1449)">
                  <path
                    d="M3.75 9.49984L7.5 13.4582L15 5.5415"
                    stroke="#72C62F"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </g>
              </svg>
            </p>
            <p className="w-[189px] h-[39px] flex items-center justify-center">
              <svg
                width="18"
                height="19"
                viewBox="0 0 18 19"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0_703_1449)">
                  <path
                    d="M3.75 9.49984L7.5 13.4582L15 5.5415"
                    stroke="#72C62F"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </g>
              </svg>
            </p>
          </div>
        </button>

        <button
          className={`w-[229px] h-[1339px] border rounded-[10px] pt-[22px] pb-[46px] px-[20px] flex flex-col ${
            selectedPlan === 2 && "border-[#FF6300] border-[3px]"
          }`}
          onClick={() => {
            handlePlanSelect(2);
            setPlanError("");
          }}
        >
          <div className="w-full flex flex-row items-center justify-between">
            <div className="flex flex-row w-[58px] items-center justify-between">
              <img
                src={require("../../../assets/BuyerProfile/StoreManager/PricingPlan/Premium.jpg")}
                alt=""
                className="w-[20px] h-[25px]"
              />
              <p className="w-[31px] h-[21px] font-semibold text-[14px] text-start text-black">
                Enterprise
              </p>
            </div>
            <p className="w-[72px] text-end h-[44px] font-semibold text-[16px] text-black leading-[22px]">
              ₹ 19,999{" "}
              <span className="font-regular text-[12px] text-black">
                / month
              </span>
            </p>
          </div>
          <div className="w-[189px] h-auto mt-[19px] [&>*:nth-child(odd)]:bg-[#F2F2F2] [&>*:nth-child(even)]:bg-white">
            <p className="w-[189px] h-[39px] flex items-center justify-center">
              <svg
                width="18"
                height="19"
                viewBox="0 0 18 19"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0_703_1449)">
                  <path
                    d="M3.75 9.49984L7.5 13.4582L15 5.5415"
                    stroke="#72C62F"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </g>
              </svg>
            </p>
            <p className="w-[189px] h-[39px] flex items-center justify-center">
              <svg
                width="18"
                height="19"
                viewBox="0 0 18 19"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0_703_1449)">
                  <path
                    d="M3.75 9.49984L7.5 13.4582L15 5.5415"
                    stroke="#72C62F"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </g>
              </svg>
            </p>
            <p className="w-[189px] h-[39px] flex items-center justify-center">
              <svg
                width="18"
                height="19"
                viewBox="0 0 18 19"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0_703_1449)">
                  <path
                    d="M3.75 9.49984L7.5 13.4582L15 5.5415"
                    stroke="#72C62F"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </g>
              </svg>
            </p>
            <p className="w-[189px] h-[39px] flex items-center justify-center text-[14px] font-semibold">
              500
            </p>
            <p className="w-[189px] h-[39px] flex items-center justify-center text-[14px] font-semibold">
              Unlimited
            </p>
            <p className="w-[189px] h-[39px] flex items-center justify-center">
              <svg
                width="18"
                height="19"
                viewBox="0 0 18 19"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0_703_1449)">
                  <path
                    d="M3.75 9.49984L7.5 13.4582L15 5.5415"
                    stroke="#72C62F"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </g>
              </svg>
            </p>
            <p className="w-[189px] h-[39px] flex items-center justify-center">
              <svg
                width="18"
                height="19"
                viewBox="0 0 18 19"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0_703_1449)">
                  <path
                    d="M3.75 9.49984L7.5 13.4582L15 5.5415"
                    stroke="#72C62F"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </g>
              </svg>
            </p>
            <p className="w-[189px] h-[39px] flex items-center justify-center">
              <svg
                width="18"
                height="19"
                viewBox="0 0 18 19"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0_703_1449)">
                  <path
                    d="M3.75 9.49984L7.5 13.4582L15 5.5415"
                    stroke="#72C62F"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </g>
              </svg>
            </p>
            <p className="w-[189px] h-[39px] flex items-center justify-center">
              <svg
                width="18"
                height="19"
                viewBox="0 0 18 19"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0_703_1449)">
                  <path
                    d="M3.75 9.49984L7.5 13.4582L15 5.5415"
                    stroke="#72C62F"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </g>
              </svg>
            </p>
            <p className="w-[189px] h-[39px] flex items-center justify-center">
              <svg
                width="18"
                height="19"
                viewBox="0 0 18 19"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0_703_1449)">
                  <path
                    d="M3.75 9.49984L7.5 13.4582L15 5.5415"
                    stroke="#72C62F"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </g>
              </svg>
            </p>
            <p className="w-[189px] h-[39px] flex items-center justify-center">
              <svg
                width="18"
                height="19"
                viewBox="0 0 18 19"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0_703_1449)">
                  <path
                    d="M3.75 9.49984L7.5 13.4582L15 5.5415"
                    stroke="#72C62F"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </g>
              </svg>
            </p>
            <p className="w-[189px] h-[39px] flex items-center justify-center text-[14px] font-semibold">
              240 Images
            </p>
            <p className="w-[189px] h-[39px] flex items-center justify-center text-[14px] font-semibold">
              120 Videos
            </p>
            <p className="w-[189px] h-[39px] flex items-center justify-center">
              <svg
                width="18"
                height="19"
                viewBox="0 0 18 19"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0_703_1449)">
                  <path
                    d="M3.75 9.49984L7.5 13.4582L15 5.5415"
                    stroke="#72C62F"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </g>
              </svg>
            </p>
            <p className="w-[189px] h-[39px] flex items-center justify-center">
              <svg
                width="18"
                height="19"
                viewBox="0 0 18 19"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0_703_1449)">
                  <path
                    d="M3.75 9.49984L7.5 13.4582L15 5.5415"
                    stroke="#72C62F"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </g>
              </svg>
            </p>
            <p className="w-[189px] h-[39px] flex items-center justify-center">
              <svg
                width="18"
                height="19"
                viewBox="0 0 18 19"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0_703_1449)">
                  <path
                    d="M3.75 9.49984L7.5 13.4582L15 5.5415"
                    stroke="#72C62F"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </g>
              </svg>
            </p>
            <p className="w-[189px] h-[39px] flex items-center justify-center">
              <svg
                width="18"
                height="19"
                viewBox="0 0 18 19"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0_703_1449)">
                  <path
                    d="M3.75 9.49984L7.5 13.4582L15 5.5415"
                    stroke="#72C62F"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </g>
              </svg>
            </p>
            <p className="w-[189px] h-[39px] flex items-center justify-center text-[14px] font-semibold">
              520 - 600
            </p>
            <p className="w-[189px] h-[39px] flex items-center justify-center">
              <svg
                width="18"
                height="19"
                viewBox="0 0 18 19"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0_703_1449)">
                  <path
                    d="M3.75 9.49984L7.5 13.4582L15 5.5415"
                    stroke="#72C62F"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </g>
              </svg>
            </p>
            <p className="w-[189px] h-[39px] flex items-center justify-center">
              <svg
                width="18"
                height="19"
                viewBox="0 0 18 19"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0_703_1449)">
                  <path
                    d="M3.75 9.49984L7.5 13.4582L15 5.5415"
                    stroke="#72C62F"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </g>
              </svg>
            </p>
            <p className="w-[189px] h-[39px] flex items-center justify-center">
              <svg
                width="18"
                height="19"
                viewBox="0 0 18 19"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0_703_1449)">
                  <path
                    d="M3.75 9.49984L7.5 13.4582L15 5.5415"
                    stroke="#72C62F"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </g>
              </svg>
            </p>
            <p className="w-[189px] h-[39px] flex items-center justify-center">
              <svg
                width="18"
                height="19"
                viewBox="0 0 18 19"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0_703_1449)">
                  <path
                    d="M3.75 9.49984L7.5 13.4582L15 5.5415"
                    stroke="#72C62F"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </g>
              </svg>
            </p>
            <p className="w-[189px] h-[39px] flex items-center justify-center">
              <svg
                width="18"
                height="19"
                viewBox="0 0 18 19"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0_703_1449)">
                  <path
                    d="M3.75 9.49984L7.5 13.4582L15 5.5415"
                    stroke="#72C62F"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </g>
              </svg>
            </p>
            <p className="w-[189px] h-[39px] flex items-center justify-center">
              <svg
                width="18"
                height="19"
                viewBox="0 0 18 19"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0_703_1449)">
                  <path
                    d="M3.75 9.49984L7.5 13.4582L15 5.5415"
                    stroke="#72C62F"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </g>
              </svg>
            </p>
            <p className="w-[189px] h-[39px] flex items-center justify-center">
              <svg
                width="18"
                height="19"
                viewBox="0 0 18 19"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0_703_1449)">
                  <path
                    d="M3.75 9.49984L7.5 13.4582L15 5.5415"
                    stroke="#72C62F"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </g>
              </svg>
            </p>
            <p className="w-[189px] h-[39px] flex items-center justify-center">
              <svg
                width="18"
                height="19"
                viewBox="0 0 18 19"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0_703_1449)">
                  <path
                    d="M3.75 9.49984L7.5 13.4582L15 5.5415"
                    stroke="#72C62F"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </g>
              </svg>
            </p>
            <p className="w-[189px] h-[39px] flex items-center justify-center">
              <svg
                width="18"
                height="19"
                viewBox="0 0 18 19"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0_703_1449)">
                  <path
                    d="M3.75 9.49984L7.5 13.4582L15 5.5415"
                    stroke="#72C62F"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </g>
              </svg>
            </p>
            <p className="w-[189px] h-[39px] flex items-center justify-center">
              <svg
                width="18"
                height="19"
                viewBox="0 0 18 19"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0_703_1449)">
                  <path
                    d="M3.75 9.49984L7.5 13.4582L15 5.5415"
                    stroke="#72C62F"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </g>
              </svg>
            </p>
            <p className="w-[189px] h-[39px] flex items-center justify-center text-[14px] font-semibold">
              Pro
            </p>
            <p className="w-[189px] h-[39px] flex items-center justify-center">
              <svg
                width="18"
                height="19"
                viewBox="0 0 18 19"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0_703_1449)">
                  <path
                    d="M3.75 9.49984L7.5 13.4582L15 5.5415"
                    stroke="#72C62F"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </g>
              </svg>
            </p>
            <p className="w-[189px] h-[39px] flex items-center justify-center">
              <svg
                width="18"
                height="19"
                viewBox="0 0 18 19"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0_703_1449)">
                  <path
                    d="M3.75 9.49984L7.5 13.4582L15 5.5415"
                    stroke="#72C62F"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </g>
              </svg>
            </p>
          </div>
        </button>
      </div>
      {planError && <p className="text-red-400 mt-1">{planError}</p>}
    </div>
    // </div>
  );
};

export default RegisterPricingPlan;
